import { RoutesRoutingModule } from './routes-routing.module';
import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

@NgModule({
  imports: [SharedModule, RoutesRoutingModule],
  declarations: [],
})
export class RoutesModule {}
